import { cn } from "src/lib/utils"

function Skeleton({
  className,
  ...props
}) {
  return (<div className={cn("animate-pulse rounded-md bg-walme-bg-elevated", className)} {...props} />);
}

export { Skeleton }
